var map = {
	"./10_nuts.png": 2456,
	"./1drink_12beer.png": 2457,
	"./1serving_8ounces.png": 2458,
	"./1serving_8ounces2.png": 2459,
	"./1serving_8ounces3.png": 2460,
	"./1serving_8ounces4.png": 2461,
	"./1serving_8ounces5.png": 2462,
	"./8ounces_1glass.png": 2463,
	"./can_1.png": 2464,
	"./can_2.png": 2465,
	"./can_3.png": 2466,
	"./cup.png": 2467,
	"./dried_serving_1/4cup.png": 2468,
	"./dried_serving_1:4cup.png": 2469,
	"./fresh_serving_1cup.png": 2470,
	"./glass_1.png": 2471,
	"./glass_2.png": 2472,
	"./golfball.png": 2473,
	"./halfthumb.png": 2474,
	"./hand_1.png": 2475,
	"./hand_2.png": 2476,
	"./hand_3.png": 2477,
	"./hand_4.png": 2478,
	"./hand_5.png": 2479,
	"./how.png": 873,
	"./serving_1/2cup.png": 2480,
	"./serving_1:2cup.png": 2481,
	"./serving_1tbsp.png": 2482,
	"./serving_3/4ounces.png": 2483,
	"./serving_3:4ounces.png": 2484,
	"./thumbx2.png": 2485,
	"./usda.png": 2486,
	"./vegetables_1cup.png": 2487,
	"./what.png": 871,
	"./wholethumb.png": 2488,
	"./why.png": 872
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2455;